/*eslint-disable*/
import React,{ useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const ServiceCategoryDropdown = ({
        field: { name },
        form: { setFieldValue },
        ...props
    }) => {

        const [serviceCategoryData, setServiceCategoryData] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        useEffect(() => {
            setIsLoading(true)
            ReadAxios({completeURL:`${process.env.REACT_APP_BASE_URL}/masters/service_category`}).then((response => {
                response?.data?.resultSet && setServiceCategoryData(response?.data?.resultSet)
                setIsLoading(false)
            }))
                .catch(error => console.log(error))
                setIsLoading(false)
        }, [])
        

        let options = []
        if (serviceCategoryData && serviceCategoryData.length > 0) {
            serviceCategoryData.map((object, index) => {
                let temp = {}
                temp.key = object.serviceCategoryId
                temp.text = object.serviceCategory
                temp.value = object.serviceCategoryId
                temp.raw = object
                return options[index] = temp
            })
        }
    return (
        <Dropdown
            selection
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={options}
            loading={isLoading}
            clearable
            {...props}
            fluid
        />

    )
}


export default ServiceCategoryDropdown